import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import PageHeader from '../components/PageHeader';
import ModularBlocks from '../components/ModularBlocks';
import { getSchemaDescription, getServiceSchemaData } from '../utils';

const PlantsForBusinessPage = () => {
  const {
    datoCmsPlantsForBusiness: {
      seoMetaTags,
      title,
      sitewideNotices,
      bannerImage,
      bannerLinks,
      modularBlocks,
      serviceSchema,
    },
  } = useStaticQuery(graphql`
    query PlantsForBusinessPageQuery {
      datoCmsPlantsForBusiness {
        seoMetaTags {
          ...GatsbyDatoCmsSeoMetaTags
        }
        title
        bannerImage {
          gatsbyImageData(width: 1400, height: 500, layout: FULL_WIDTH)
          alt
        }
        bannerLinks {
          id
          text
          page {
            ...LinkFragment
          }
        }
        modularBlocks {
          ...AccordionModularBlockFragment
          ...CompanyReviewsModularBlockFragment
          ...ContactFormModularBlockFragment
          ...ContainedImageModularBlockFragment
          ...ContentModularBlockFragment
          ...ExternalVideoModularBlockFragment
          ...FeaturedLogosModularBlockFragment
          ...FeaturedProjectsModularBlockFragment
          ...FullWidthImageModularBlockFragment
          ...HighlightedTextModularBlockFragment
          ...IconCtasModularBlockFragment
          ...ImageContentModularBlockFragment
          ...ImageGalleryModularBlockFragment
          ...ImageLinkCardsModularBlockFragment
          ...InternalVideoModularBlockFragment
          ...TabsModularBlockFragment
          ...TeamProfilesModularBlockFragment
          ...TestimonialsModularBlockFragment
        }
        serviceSchema {
          serviceType
          serviceAreaServed
        }
        sitewideNotices {
          text
        }
      }
    }
  `);

  const serviceData = getServiceSchemaData({
    serviceSchema,
    seoMetaTags,
    title,
  });

  return (
    <Layout
      title={title}
      description={getSchemaDescription(seoMetaTags)}
      service={serviceData}
      sitewideNotices={sitewideNotices}
    >
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        {bannerImage ? (
          <Banner image={bannerImage} heading={title} links={bannerLinks} />
        ) : (
          <PageHeader heading={title} />
        )}
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export default PlantsForBusinessPage;
